/** Query parameter that triggers the "account deleted" confirmation. */
export const ACCOUNT_DELETED_PARAM = "accountDeleted";

/** The literal word users type to confirm account deletion (all languages). */
export const DELETE_CONFIRMATION_WORD = "DELETE";
